
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { IconButton } from 'office-ui-fabric-react/lib/Button';

import OverviewTitle from './OverviewTitle';
import IfComp from '../common/IfComp';
import MapState from './Map.state';

const classNames = mergeStyleSets({
    root: {
        padding: 16
    },
    title: {
        paddingBottom: 16
    },
    content: {
        paddingRight: 8,
        marginBottom: 8,
        width: 1000,
        height: 700
    },
    closeIcon: {
    }
});

const MapContent = ({parItem}) => {
    return (
        <MapState
            parItem={parItem}
        />
    )
}

const MapDialog = ({open, onDismiss, parItem}) => {

    return (
        <Modal
            className={classNames.root}
            isOpen={open}
            isModeless={false}
            isDarkOverlay={true}
            dragOptions={false}
            onDismiss={onDismiss}
        >
            <Stack className={classNames.root}>
                <Stack horizontal className={classNames.title}>
                    <Stack.Item grow>
                        <OverviewTitle title={`Mapa`} />
                    </Stack.Item>
                    <IconButton
                        styles={classNames.closeIcon}
                        iconProps={{iconName: 'Cancel'}}
                        ariaLabel="Zavřít"
                        onClick={onDismiss}
                    />
                </Stack>
                <Stack.Item className={classNames.content}>
                    <IfComp cond={!!parItem}>
                        <MapContent parItem={parItem} />
                    </IfComp>
                </Stack.Item>
            </Stack>
        </Modal>
    );
}

export default MapDialog;
